import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { allIcons } from "../../../assets";
import { t } from "i18next";
import GlobalButton from "../../CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { useNavigate } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    maxWidth: "450px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .close-icon-btn": {
    position: "absolute",
    top: "5px",
    right: "5px",
  },
}));

let paramsData = {};

const ConfirmationDialog = forwardRef(({ showCloseBtn }, ref) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const activeTab = useSelector((state) => state.activeTab.tabs);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog: () => setOpen(false),
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      {showCloseBtn && (
        <IconButton className="close-icon-btn" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      )}

      {paramsData.type === "worker_appoitment_accepted" && (
        <>
          <DialogTitle
            variant="h1"
            fontWeight={700}
            fontSize={"1.5rem"}
            fontFamily={"inter"}
            sx={{ m: 0, p: 2, textAlign: "center" }}
            id="customized-dialog-title"
          >
            {t("updated")} !
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              textAlign={"center"}
              color={"custom.venetianRed"}
            >
              {t("confirmationEmailNotice")}
            </Typography>
            <Box textAlign={"center"} mt={3}>
              <img src={allIcons.conformIcon} width={50} />
            </Box>
          </DialogContent>
        </>
      )}

      {paramsData.type === "worker_appoitment_completed" && (
        <>
          <DialogTitle
            variant="h1"
            fontWeight={700}
            fontSize={"1.5rem"}
            fontFamily={"inter"}
            sx={{ m: 0, p: 2, textAlign: "center" }}
            id="customized-dialog-title"
          >
            {t("appointmentCompletedSuccess")} !
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              textAlign={"center"}
              color={"custom.venetianRed"}
            >
              {t("confirmationEmailSent")}
            </Typography>
            <Box textAlign={"center"} mt={3}>
              <img src={allIcons.conformIcon} width={50} />
            </Box>
          </DialogContent>
        </>
      )}

      {paramsData.type === "staff_limit_reached" && (
        <>
          <DialogTitle
            variant="h1"
            fontWeight={700}
            fontSize={"1.5rem"}
            fontFamily={"inter"}
            sx={{ m: 0, p: 2, textAlign: "center" }}
            id="customized-dialog-title"
          >
            {t("staffLimitReachedHeading")} !
          </DialogTitle>
          <DialogContent dividers>
            <Typography
              variant="body1"
              textAlign={"center"}
              color={"custom.venetianRed"}
            >
              {t("staffLimitReachedMessage")}
            </Typography>
            <Stack justifyContent={"center"} alignItems={"center"} mt={3}>
              <GlobalButton
                variant={"custom_contained"}
                btnText={t("staffLimitReachedButtonText")}
                handleClickBtn={() => {
                  setOpen(false);
                  dispatch(
                    setActiveTab({
                      ...activeTab,
                      compnay_subscription: "subscription",
                    })
                  );
                  navigate("/company/subscription");
                }}
              />
            </Stack>
          </DialogContent>
        </>
      )}
    </BootstrapDialog>
  );
});

export default ConfirmationDialog;
